export default __webpack_public_path__ + "static/media/@vilumahome.dd6d329f.jpg";